// extracted by css-extract-rspack-plugin
export default {"root":"root-uB_h3Z","disabled":"disabled-SgQtTk","unit":"unit-mGdlgA","suffix":"suffix-LNzZ7M text-sm-medium"};